export const LOCAL_STORAGE_RRW_SESSION_ID_KEY = 'ragRecommendationWidgetSessionId';
export const RAG_RECOMMENDATION_WIDGET_MESSAGE_PREFIX = 'rag-recommendation-widget' as const;
export const RAG_RECOMMENDATION_WIDGET_IFRAME_Z_INDEX = 100;

export const RAG_RECOMMENDATION_WIDGET_MESSAGE_TYPE = {
  ready: `${RAG_RECOMMENDATION_WIDGET_MESSAGE_PREFIX}:ready`,
  resize: `${RAG_RECOMMENDATION_WIDGET_MESSAGE_PREFIX}:resize`,
  chatOpen: `${RAG_RECOMMENDATION_WIDGET_MESSAGE_PREFIX}:chat-open`,
  chatClose: `${RAG_RECOMMENDATION_WIDGET_MESSAGE_PREFIX}:chat-close`,
  iframeClick: `${RAG_RECOMMENDATION_WIDGET_MESSAGE_PREFIX}:iframe-click`,
} as const;

type RRWidgetIframeOutboundMessageReady = { type: typeof RAG_RECOMMENDATION_WIDGET_MESSAGE_TYPE.ready };

type RRWidgetIframeOutboundMessageResize = {
  type: typeof RAG_RECOMMENDATION_WIDGET_MESSAGE_TYPE.resize;
  size: { width: number; height: number };
};

type RRWidgetIframeOutboundMessageChatOpen = {
  type: typeof RAG_RECOMMENDATION_WIDGET_MESSAGE_TYPE.chatOpen;
};

type RRWidgetIframeOutboundMessageChatClose = {
  type: typeof RAG_RECOMMENDATION_WIDGET_MESSAGE_TYPE.chatClose;
  size?: { width: number; height: number };
};

type RRWidgetIframeOutboundMessageIframeClick = {
  type: typeof RAG_RECOMMENDATION_WIDGET_MESSAGE_TYPE.iframeClick;
};

export type RRWidgetOutboundMessage =
  | RRWidgetIframeOutboundMessageReady
  | RRWidgetIframeOutboundMessageResize
  | RRWidgetIframeOutboundMessageChatOpen
  | RRWidgetIframeOutboundMessageChatClose
  | RRWidgetIframeOutboundMessageIframeClick;
